import { PHOTO_UPLOAD_MAX_DIMENSION, PHOTO_UPLOAD_QUALITY } from '@gearbelt/global';
import Compressor from 'compressorjs';

// Photographic PNGs over this size re-encode to JPEG; PNG output would stay several MB.
const PNG_TO_JPEG_ABOVE_BYTES = 200_000;

export function shrinkPhoto(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: PHOTO_UPLOAD_QUALITY,
      maxWidth: PHOTO_UPLOAD_MAX_DIMENSION,
      convertSize: PNG_TO_JPEG_ABOVE_BYTES,
      success: (result) => {
        const name = result.type === file.type ? file.name : `${file.name.replace(/\.[^.]+$/, '')}.jpg`;
        resolve(new File([result], name, { type: result.type }));
      },
      error: reject,
    });
  });
}
